export default {
  hero_label: 'SERVICE',
  hero_title_en: 'AIX Manager',
  hero_title_ja: 'AIX Manager',
  hero_desc: 'From post-implementation AI operations and management to business automation and data utilization, we provide continuous accompaniment for organizational digital transformation.',
  overview_label: 'OVERVIEW',
  overview_title: 'Service Overview',
  overview_desc: 'AIX Manager is an AI operations and management support service that resolves post-implementation challenges such as "cannot use it effectively," "has not taken root," and "is not producing results."\n\nFrom promoting business process automation to building data utilization infrastructure and cross-organizational change management, dedicated teams accompany you through all post-implementation phases. We support the transformation toward a sustainable digital organization where AI and humans coexist.',
  services_label: 'SERVICES',
  services_title: 'Main Service Areas',
  service_1_title: 'AI Implementation & Operations Management',
  service_1_desc: 'Supporting the design of operational frameworks and management systems after AI implementation. We establish AI utilization mechanisms that take root at the operational level, from tool selection to full adoption.',
  service_2_title: 'Business Automation Promotion',
  service_2_desc: 'Designing and implementing business process automation using AI for repetitive tasks, data processing, and reporting. We shift human resources toward higher-value-added activities.',
  service_3_title: 'Data Utilization & Analytics Infrastructure',
  service_3_desc: 'Integrating and organizing scattered internal data to build an analytics infrastructure that supports decision-making. We support dashboard design through operational adoption.',
  service_4_title: 'Organizational Change Management',
  service_4_desc: 'Driving organizational transformation accompanying the introduction of AI and digital tools. We continuously support cross-departmental digital transformation while eliminating frontline resistance.',
  challenges_label: 'CHALLENGES',
  challenges_title: 'We Solve These Challenges',
  challenge_1: 'AI/tools were introduced but have not taken root at the operational level',
  challenge_2: 'ROI of introduced AI is unclear and utilization has stalled',
  challenge_3: 'Data is scattered across the organization and cannot be utilized effectively',
  challenge_4: 'Want to advance business automation but do not know where to start',
  challenge_5: 'Data linkage and information sharing between departments is not working smoothly',
  challenge_6: 'Organization-wide digital transformation has been left to a few dedicated staff members',
  reasons_label: 'WHY AIX JAPAN',
  reasons_title: 'Why Companies Choose AIX JAPAN',
  reason_1_title: 'Confidence Starting from Current State Diagnosis',
  reason_1_desc: 'We carefully diagnose existing systems, workflows, and data assets before designing support content. We propose optimal solutions tailored to your organization, not one-size-fits-all approaches.',
  reason_2_title: 'Transformation Support Rooted in the Frontlines',
  reason_2_desc: 'We also handle change management to eliminate resistance to AI and tool adoption. We build a system where the entire organization can master digital tools, moving away from reliance on a few individuals.',
  reason_3_title: 'Maximizing Data Asset Value',
  reason_3_desc: 'We integrate and organize scattered data to build an analytics infrastructure directly connected to business decision-making. We support the cultivation of a data-driven culture.',
  reason_4_title: 'Continuous Accompaniment Model',
  reason_4_desc: 'We do not stop at introduction but provide long-term support for post-implementation monitoring, improvement, and expansion. We are a partner that maintains and expands results.',
  auto_label: 'AUTOMATION',
  auto_title: 'Examples of Automatable Tasks',
  auto_subtitle: 'We design and implement customized automation tailored to your challenges',
  auto_1_title: 'Document & Report Creation',
  auto_1_desc: 'AI automatically generates routine documents such as monthly reports, proposal materials, and meeting minutes. Reduces creation time by up to 90%.',
  auto_2_title: 'Email & Inquiry Response',
  auto_2_desc: 'Automates customer inquiry classification, draft reply generation, and escalation routing.',
  auto_3_title: 'Data Collection & Aggregation',
  auto_3_desc: 'Automatically builds data pipelines for web scraping, API integration, and CSV processing.',
  auto_4_title: 'Approval & Workflow',
  auto_4_desc: 'Digitizes application and approval workflows with AI-based primary screening to improve processing speed.',
  auto_5_title: 'Dashboard & KPI Management',
  auto_5_desc: 'Auto-updates real-time KPI dashboards. Instantly grasp the numbers needed for management decisions.',
  auto_6_title: 'Customer Support',
  auto_6_desc: 'Improves response quality through FAQ chatbots, inquiry classification, and automatic organization of customer interaction history.',
  flow_label: 'FLOW',
  flow_title: 'Implementation Flow',
  flow_intro: 'From diagnosis to operational adoption, we clarify the work and deliverables of each step. Durations vary by scope and are indicative only.',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-search-eye-line',
      title: 'Current State Diagnosis',
      note: 'Free initial consult',
      duration: 'approx. 2-4 weeks',
      activities: [
        'Survey of existing systems, workflows, and data assets',
        'Identification of automation/data opportunities with a cost-benefit outlook',
      ],
      deliverables: ['Diagnosis report', 'Prioritized list of automation candidates'],
      clientAsks: ['Sharing of workflow documents and system architecture', 'Cooperation with on-site interviews'],
    },
    {
      no: '02',
      icon: 'ri-draft-line',
      title: 'Optimization Design',
      duration: 'approx. 2-4 weeks',
      activities: [
        'Overall design of automation, data utilization, and AI operations',
        'Prioritization, implementation planning, and security/permission design',
      ],
      deliverables: ['Overall design document', 'Implementation plan'],
      clientAsks: ['Agreement on priorities', 'A liaison with your IT department'],
    },
    {
      no: '03',
      icon: 'ri-settings-4-line',
      title: 'Implementation & Automation',
      duration: 'approx. 1-3 months',
      activities: [
        'Implementation of automation workflows and analytics foundations with staged releases',
        'On-site adoption training',
      ],
      deliverables: ['Working automation workflows and dashboards', 'Operation manuals'],
      clientAsks: ['Frontline participation in test runs and feedback'],
    },
    {
      no: '04',
      icon: 'ri-loop-right-line',
      title: 'Continuous Operation Support',
      duration: 'Ongoing (monthly)',
      activities: [
        'Monitoring, improvement, and expansion design',
        'Support for internalizing your in-house operations team',
      ],
      deliverables: ['Operations report', 'Improvement and expansion proposals'],
      clientAsks: ['Participation in a monthly review meeting'],
    },
  ],
};